<template>
    <div>
        <div class="loader__container" role="alertdialog" aria-busy="true" aria-live="assertive">
            <img :src="this.imagePath + '/loader' + this.fileType" aria-hidden="true" />
            <span class="sr-only" v-translate>content.is.being.loaded</span>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            imagePath: String
        },
        data: () => ({}),
        computed: {
            fileType: function() {
                const  isIE11 = !!window.MSInputMethodContext && !!document.documentMode
                if ( isIE11 ) {
                    return '.gif'
                } else {
                    return '.svg'
                }
            }
        },
        methods: {}
    }
</script>

